import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/Button';
import { ApiError } from '../../services/api';

// Сюди падає все, що кинув лоадер або рендер сторінки.
export function RouteError() {
  const error = useRouteError();

  let title = 'Щось пішло не так';
  let detail = 'Спробуйте оновити сторінку.';
  let code: string | undefined;

  if (error instanceof ApiError) {
    if (error.status === 0) {
      title = 'Немає звʼязку з сервером';
      detail = 'Спробуйте за хвилину.';
    } else if (error.status === 401 || error.status === 403) {
      title = 'Немає доступу';
      detail = error.message;
    } else {
      title = 'Не вдалося завантажити';
      detail = error.message;
      code = String(error.status);
    }
  } else if (isRouteErrorResponse(error)) {
    title = 'Не вдалося завантажити';
    code = String(error.status);
  }

  return (
    <div style={{ padding: 'var(--sp-6)', maxWidth: 560 }}>
      <Alert
        tone="bad"
        title={title}
        code={code}
        action={
          <Button small onClick={() => window.location.reload()}>
            Оновити сторінку
          </Button>
        }
      >
        {detail}
      </Alert>
    </div>
  );
}
